import { memo, useMemo } from "react";

import { classNames } from "shared/lib/classNames/classNames";

import cls from "./SociometryResultsTable.module.scss";
import { PupilResult } from "shared/types/sociometry";
import {
    getSociometryDescription,
    getSociometryRole,
    getSociometryRoleColors,
    getSociometryStarsIds,
    getSociometryTitle,
} from "../lib/sociometryRoles";
import { Popup } from "shared/ui/Popup";

interface SociometryResultItemProps {
    starsIds: Set<string>;
    score: PupilResult;
    onClickRow: (pupilId: string) => void;
    numberRow: number;
}

export const SociometryResultItem = memo((props: SociometryResultItemProps) => {
    const { score, onClickRow, starsIds, numberRow } = props;

    const background = getSociometryRoleColors(getSociometryRole(score, starsIds));
    const noBackground = background === "";

    const description = getSociometryDescription(getSociometryRole(score, starsIds));
    return (
        <Popup key={score.pupil?._id} dangerouslySetInnerHTML={description} background={background}>
            <div
                key={score.pupil?._id}
                className={cls.row}
                onClick={() => onClickRow(score.pupil?._id)}
                title={getSociometryTitle(getSociometryRole(score, starsIds))}
            >
                <div
                    className={classNames(cls.badge, { [cls.noBackground]: noBackground })}
                    style={{ backgroundColor: background }}
                >
                    {numberRow}
                </div>
                <div>{`${score.pupil?.surname} ${score.pupil?.name} ${score.pupil?.patronymic || ""}`.trim()}</div>

                <div className={cls.center}>{score.positiveScore}</div>
                <div className={cls.center}>{score.negativeScore}</div>
                <div className={cls.center}>{score.totalScore}</div>
            </div>
        </Popup>
    );
});

SociometryResultItem.displayName = "SociometryResultItem";

interface SociometryResultsTableProps {
    className?: string;
    scores: PupilResult[];
    onClickRow: (pupilId: string) => void;
}

export const SociometryResultsTable = memo((props: SociometryResultsTableProps) => {
    const { className, scores, onClickRow } = props;
    const starsIds = useMemo(() => getSociometryStarsIds(scores), [scores]);

    return (
        <div className={classNames(cls.sociometryResultsTable, {}, [className])}>
            <div className={cls.rowHeader}>
                <div>№</div>
                <div>ФИО</div>
                <div className={cls.center}>+</div>
                <div className={cls.center}>-</div>
                <div className={cls.center}>Итог</div>
            </div>
            {scores.map((score, index) => (
                <SociometryResultItem
                    onClickRow={onClickRow}
                    numberRow={index + 1}
                    score={score}
                    starsIds={starsIds}
                    key={score.pupil?._id}
                />
            ))}
        </div>
    );
});

SociometryResultsTable.displayName = "SociometryResultsTable";
